<template>
  <div class="wrap">
    <v-data-table class="app-table" v-model="selected" :headers="headers" :items="data" :single-select="singleSelect" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer="hide-default-footer" item-key="id" @page-count="pageCount = $event" :no-data-text="$t('common.nodata')">
      <template v-slot:item.status="{ item }"><span>{{ getStatus(item.status) }}</span></template>
    </v-data-table>
    <div class="text-center mt-10">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
import { SITE_STATUS } from '@/libs/enum'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      singleSelect: false,
      selected: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        {
          text: this.$t('tableSiteManagement.headers.status'),
          value: 'status'
        },
        {
          text: this.$t('tableSiteManagement.headers.id'),
          value: 'id'
        },
        {
          text: this.$t('tableSiteManagement.headers.name'),
          value: 'name'
        },
        {
          text: this.$t('tableSiteManagement.headers.location'),
          value: 'location'
        },
        {
          text: this.$t('tableSiteManagement.headers.bikeRacks'),
          value: 'bikeRacks'
        },
        {
          text: this.$t('tableSiteManagement.headers.startAt'),
          value: 'startAt'
        }
      ]
    }
  },
  methods: {
    getStatus (status) {
      return this.$t(`tableSiteManagement.status.${SITE_STATUS[status]}`)
    }
  }
}
</script>
